import { SAVE_EXACT_ORDERS } from "../constants/Exact";

/**
 * De opgehaalde Exact-verkooporders in de store zetten.
 *
 * `fetchedAt` en `query` staan erbij zodat de pagina kan laten zien wanneer de
 * lijst voor het laatst is opgehaald, en zodat hij weet of de huidige inhoud bij
 * de gekozen filters hoort — is dat niet zo, dan haalt hij opnieuw op in plaats
 * van een lijst te tonen die iets anders bevat dan de filterbalk suggereert.
 */
export function saveExactOrders(orders, query = null) {
  return (dispatch) => {
    dispatch({
      type: SAVE_EXACT_ORDERS,
      payload: { orders, query, fetchedAt: Date.now() },
    });
  };
}
